import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { waitFor } from 'lp-hoc'
import { Spinner } from 'lp-components'
import { SectionBlock, SectionHeader, PortalHeader } from 'components'
import { buildInternalApiUrl, useCommunity } from 'utils'
import * as apiActions from 'api-actions'
import { selectors as globalSelectors } from 'school-portal-reducer'
import { selectors } from '../reducer'

const propTypes = {
  school: Types.school.isRequired,
  archives: PropTypes.arrayOf(PropTypes.object),
  fetchSurveyArchives: PropTypes.func.isRequired,
}

const defaultProps = {
  archives: null,
}

function SurveyArchive({ school, archives, fetchSurveyArchives }) {
  const {
    subdomain,
    defaultBranding: { dashboardHeader },
  } = useCommunity()
  const isSwpa = subdomain === 'swpa'

  useEffect(() => {
    fetchSurveyArchives()
  }, [fetchSurveyArchives])

  const buildDownloadUrl = (schoolYearId) =>
    buildInternalApiUrl({
      url: `/schools/${school.id}/survey_archive.pdf`,
      query: { schoolYear: schoolYearId },
    })

  const hasArchives = archives && archives.length > 0

  return (
    <div>
      <PortalHeader title="Survey Archive" backgroundImage={dashboardHeader} />
      <div className="content-block-container">
        <div className="survey-archive-info">
          <p>
            The Survey Archive contains downloadable PDF copies of all your
            previously completed surveys, organized by year. As you complete new
            surveys, they will automatically be added to the archive, so check
            back to access the latest results.
          </p>
          {isSwpa && <p>Note: The archive begins with the 2025-26 Survey.</p>}
        </div>

        <SectionBlock>
          <SectionHeader>
            <h3>Download Previous Surveys</h3>
          </SectionHeader>

          {!archives ? (
            <Spinner />
          ) : hasArchives ? (
            <table className="survey-archive-table">
              <thead>
                <tr>
                  <th scope="col">School Year</th>
                  <th scope="col">Survey Download</th>
                </tr>
              </thead>
              <tbody>
                {archives.map((archive) => (
                  <tr key={archive.id}>
                    <td>School Year {archive.schoolYearNumber}</td>
                    <td>
                      <a href={buildDownloadUrl(archive.schoolYearId)}>
                        Download Survey
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="survey-archive-empty">
              You don&apos;t have any completed surveys yet. Once you submit a
              survey, a downloadable copy will automatically appear here in your
              archive.
            </p>
          )}
        </SectionBlock>
      </div>
    </div>
  )
}

SurveyArchive.propTypes = propTypes
SurveyArchive.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    school: globalSelectors.school(state),
    archives: selectors.archives(state),
  }
}

const mapDispatchToProps = {
  fetchSurveyArchives: apiActions.fetchSurveyArchives,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  waitFor('school')
)(SurveyArchive)
